export function Confirm(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3.2C7.1399 3.2 3.2 7.1399 3.2 12C3.2 16.8601 7.1399 20.8 12 20.8C16.8601 20.8 20.8 16.8601 20.8 12C20.8 7.1399 16.8601 3.2 12 3.2ZM0.800003 12C0.800003 5.81441 5.81441 0.800003 12 0.800003C18.1856 0.800003 23.2 5.81441 23.2 12C23.2 18.1856 18.1856 23.2 12 23.2C5.81441 23.2 0.800003 18.1856 0.800003 12Z"
          fill="currentColor"
        />
        <path
          d="M16.9057 8.52119C17.1704 7.81085 16.8627 7.00007 16.1728 6.65597L16.0331 6.59494C15.3273 6.3285 14.5217 6.63814 14.1798 7.33257L10.7408 14.3144L9.59341 13.0287L9.47859 12.9132C8.92044 12.4098 8.0633 12.4002 7.49312 12.9159C6.88221 13.4685 6.83206 14.4149 7.38111 15.0298L8.77398 16.5896L8.95553 16.7744C9.14536 16.9503 9.35936 17.0984 9.5913 17.2141C10.9406 17.887 12.5764 17.3316 13.245 15.9736L16.845 8.66175L16.9057 8.52119Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
